document.addEventListener('DOMContentLoaded', () => {
  // ---------- Scope to THIS section ----------
  const sectionEl = document.querySelector('.section-collection-main');

  // Fallback to document if element isn't inside the section (overlay lives outside)
  const q  = (sel) => (sectionEl && sectionEl.querySelector(sel)) || document.querySelector(sel);
  const qa = (sel) => (sectionEl ? sectionEl.querySelectorAll(sel) : document.querySelectorAll(sel));

  const sidebar   = q('#collection-filters');
  const overlay   = q('#mobile-filter-overlay');
  const grid      = q('#products-grid');
  const clearBtn  = q('#clear-filters');
  const countEl   = q('#filtered-count');

  const closeFiltersBtn = q('.close-filters-btn');
  const applyFiltersBtn = q('#apply-filters');
  const clearMobileBtn  = q('#clear-filters-mobile');
  const mobileToggleBtn = q('#mobile-filter-toggle');

  // paginate/meta
  const metaEl       = q('#collection-paginate-data');
  const totalPages   = parseInt(metaEl?.dataset.totalPages || '1', 10);
  const collUrl      = metaEl?.dataset.collectionUrl || window.location.pathname;
  const sectionId    = metaEl?.dataset.sectionId || sectionEl?.dataset.sectionId;
  const loadAllBtn   = q('#load-all');

  const preset       = sectionEl?.dataset.filterPreset || 'generic';

  let cards          = Array.from(grid.querySelectorAll('.product-card'));
  let allLoaded      = false;
  let loadingAllPromise = null;

  // Cache frequently-used values on cards (price, title, created)
  function cacheCard(card) {
    if (card._cached) return;
    card._price   = (parseInt(card.dataset.price || '0', 10) / 100) || 0;
    card._title   = (card.querySelector('.product-title')?.textContent || '').trim();
    card._created = parseInt(card.dataset.created || '0', 10) || 0;
    card._cached  = true;
  }
  cards.forEach(cacheCard);

  // ---------- Mobile drawer ----------
  function openSidebar() {
    sidebar?.classList.add('active');
    overlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    sidebar?.classList.remove('active');
    overlay?.classList.remove('active');
    document.body.style.overflow = '';
  }
  mobileToggleBtn?.addEventListener('click', openSidebar);
  overlay?.addEventListener('click', closeSidebar);
  closeFiltersBtn?.addEventListener('click', closeSidebar);
  applyFiltersBtn?.addEventListener('click', () => { scheduleFilter(); closeSidebar(); });
  clearMobileBtn?.addEventListener('click', () => {
    qa('.filter-option input[type="checkbox"]').forEach(i => (i.checked = false));
    scheduleFilter();
  });

  // ---------- Accordions ----------
  function scrollContentIntoView(contentEl) {
    if (!sidebar || !contentEl) return;
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;
    const header = sidebar.querySelector('.sidebar-header');
    const headerH = header ? header.offsetHeight : 0;

    if (isMobile) {
      const desired = Math.max(0, contentEl.offsetTop - headerH - 8);
      sidebar.scrollTo({ top: desired, behavior: 'smooth' });
    } else {
      contentEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  qa('.filter-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.filter;
      const content = q(`[data-filter-content="${id}"]`);
      const willOpen = !btn.classList.contains('active');
      btn.classList.toggle('active');
      content?.classList.toggle('active');
      if (willOpen && content) scrollContentIntoView(content);
    });
  });

  // ---------- Selection helpers ----------
  function getSelected() {
    const selected = {};
    qa('.filter-option input[type="checkbox"]:checked').forEach(i => {
      (selected[i.name] ||= []).push((i.value || '').toLowerCase());
    });
    const sort = q('input[name="sort_by"]:checked')?.value || 'manual';
    selected.__sort = sort;
    return selected;
  }

  const keyMap = {
    taxonomy: 'taxonomy',
    expander_size: 'expanderSize',
    pod_size: 'podSize',
    cabin_size: 'cabinSize',
    dome_width: 'domeWidth',
    beds: 'beds',
    ceiling_height: 'ceilingHeight',
    price_range: 'price'
  };

  function passValue(card, name, values) {
    if (!values || !values.length) return true;

    if (name === 'price_range') {
      // values look like "0-20000"
      return values.some(r => {
        const [lo, hi] = r.split('-').map(Number);
        return card._price >= lo && card._price <= hi;
      });
    }

    const key = keyMap[name];
    const cardVal = (card.dataset[key] || '').toLowerCase();
    return values.some(v => cardVal.includes(v));
  }

  // ---------- Filter (batched) ----------
  let filterScheduled = false;
  function scheduleFilter() {
    if (filterScheduled) return;
    filterScheduled = true;
    requestAnimationFrame(() => {
      filterScheduled = false;
      doFilter();
    });
  }

  function doFilter() {
    // Kick off background load of all pages if needed (non-blocking)
    if (!allLoaded && totalPages > 1 && !loadingAllPromise) {
      loadingAllPromise = loadAllProducts(true).then(() => {
        // Re-cache and re-filter once everything has landed
        cards = Array.from(grid.querySelectorAll('.product-card'));
        cards.forEach(cacheCard);
        doFilter();
      });
    }

    const sel = getSelected();

    let visible = 0;
    // Only touch DOM when necessary
    for (const card of cards) {
      let show = true;
      for (const [name, vals] of Object.entries(sel)) {
        if (name.startsWith('__')) continue;
        if (!passValue(card, name, vals)) { show = false; break; }
      }
      const shouldHide = !show;
      if (shouldHide) {
        if (card.style.display !== 'none') card.style.display = 'none';
      } else {
        if (card.style.display === 'none') card.style.display = '';
        visible++;
      }
    }

    if (countEl) countEl.textContent = visible;
    if (clearBtn) {
      const any = Object.keys(sel).some(k => !k.startsWith('__') && sel[k]?.length);
      clearBtn.style.display = any ? 'inline-block' : 'none';
    }

    doSort(sel.__sort);
  }

  function doSort(mode) {
    const vis = cards.filter(c => c.style.display !== 'none');
    const hid = cards.filter(c => c.style.display === 'none');
    const collator = new Intl.Collator(undefined, { sensitivity: 'base' });

    vis.sort((a,b) => {
      switch (mode) {
        case 'price-ascending':  return a._price - b._price;
        case 'price-descending': return b._price - a._price;
        case 'title-ascending':  return collator.compare(a._title, b._title);
        case 'title-descending': return collator.compare(b._title, a._title);
        case 'created-descending': return b._created - a._created;
        case 'best-selling':
        case 'manual':
        default: return 0;
      }
    });

    // Append visible first, then hidden — one batch
    const frag = document.createDocumentFragment();
    vis.forEach(el => frag.appendChild(el));
    hid.forEach(el => frag.appendChild(el));
    grid.appendChild(frag);
  }

  // ---------- Load ALL products (background, non-blocking) ----------
  async function loadAllProducts(silent) {
    if (allLoaded || totalPages <= 1 || !sectionId || !collUrl) return;

    if (loadAllBtn && !silent) { loadAllBtn.disabled = true; loadAllBtn.textContent = 'Loading…'; }

    // fetch sequentially to keep memory/cpu under control
    for (let p = 2; p <= totalPages; p++) {
      const url = `${collUrl}?section_id=${encodeURIComponent(sectionId)}&page=${p}`;
      try {
        const res = await fetch(url, { credentials: 'same-origin' });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const scope = doc.querySelector('[data-section-id="'+sectionId+'"]') || doc;
        const pageGrid = scope.querySelector('#products-grid');
        if (!pageGrid) continue;

        const newCards = Array.from(pageGrid.querySelectorAll('.product-card'));
        const frag = document.createDocumentFragment();
        newCards.forEach(card => {
          // cache before insert
          cacheCard(card);
          // bind gallery
          const g = card.querySelector('.product-gallery');
          if (g) bindGallery(g);
          frag.appendChild(card);
        });
        grid.appendChild(frag);
      } catch (e) {
        // fail soft
        console.warn('Load page failed', p, e);
      }
    }

    allLoaded = true;

    if (loadAllBtn && !silent) {
      loadAllBtn.textContent = 'All products loaded';
      loadAllBtn.disabled = true;
    }
  }

  loadAllBtn?.addEventListener('click', async () => {
    if (allLoaded) return;
    await loadAllProducts(false);
    // re-collect cards & re-filter after explicit load
    cards = Array.from(grid.querySelectorAll('.product-card'));
    cards.forEach(cacheCard);
    scheduleFilter();
  });

  // listen for changes
  qa('.filter-option input').forEach(i => i.addEventListener('change', scheduleFilter));
  qa('input[name="sort_by"]').forEach(r => r.addEventListener('change', () => doSort(r.value)));
  clearBtn?.addEventListener('click', () => {
    qa('.filter-option input[type="checkbox"]').forEach(i => (i.checked = false));
    scheduleFilter();
  });

  // ---------- Gallery: desktop hover, mobile simple swipe ----------
  function activateIndex(el, idx) {
    const imgs = el._imgs;
    if (!imgs || !imgs.length) return;
    idx = Math.min(Math.max(idx, 0), imgs.length - 1);
    if (idx === el._idx) return;

    imgs.forEach((im, i) => im.classList.toggle('active', i === idx));
    const dots = el.querySelectorAll('.gallery-dot');
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    el._idx = idx;

    // lazy load all frames on first interaction
    if (!el._hydrated) {
      imgs.forEach(img => {
        if (img.dataset && img.dataset.src && !img.dataset._loaded) {
          img.src = img.dataset.src;
          img.dataset._loaded = '1';
        }
      });
      el._hydrated = true;
    }
  }

  function bindGallery(el) {
    const imgs = Array.from(el.querySelectorAll('.gallery-image'));
    el._imgs = imgs;
    el._idx = Math.max(0, imgs.findIndex(i => i.classList.contains('active')));

    const hasHover = window.matchMedia('(hover: hover)').matches;

    // Desktop: hover scrub
    if (hasHover) {
      el.addEventListener('mousemove', (e) => {
        const rect = el.getBoundingClientRect();
        const frac = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
        const idx = Math.floor(frac * imgs.length);
        activateIndex(el, idx);
      }, { passive: true });

      el.addEventListener('mouseleave', () => activateIndex(el, 0), { passive: true });
      return;
    }

    // Mobile: simple left/right swipe (one image per swipe)
    let startX = 0;
    let startY = 0;
    let tracking = false;
    const SWIPE_THRESHOLD = 28; // px
    const DOMINANCE = 8;        // horizontal must exceed vertical by this many px

    const onPointerDown = (x, y) => {
      tracking = true;
      startX = x;
      startY = y;
    };
    const onPointerMove = (x, y, ev) => {
      if (!tracking) return;
      const dx = x - startX;
      const dy = y - startY;

      // if horizontal intent is clear, block native horizontal scrolling
      if (Math.abs(dx) > Math.abs(dy) + DOMINANCE) {
        if (ev && typeof ev.preventDefault === 'function') ev.preventDefault();
      }
    };
    const onPointerUp = (x, y, ev) => {
      if (!tracking) return;
      tracking = false;

      const dx = x - startX;
      const dy = y - startY;

      // Only treat as swipe if horizontal distance is dominant and past threshold
      if (Math.abs(dx) > Math.abs(dy) + DOMINANCE && Math.abs(dx) > SWIPE_THRESHOLD) {
        if (ev && typeof ev.preventDefault === 'function') ev.preventDefault();
        const dir = dx < 0 ? 1 : -1; // left swipe -> next, right swipe -> prev
        activateIndex(el, (el._idx || 0) + dir);
      }
    };

    // Prefer Pointer Events when available
    if ('PointerEvent' in window) {
      el.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse') return; // mouse handled by hover path
        onPointerDown(e.clientX, e.clientY);
      }, { passive: true });

      el.addEventListener('pointermove', (e) => {
        if (e.pointerType === 'mouse') return;
        onPointerMove(e.clientX, e.clientY, e);
      }, { passive: false });

      const peEnd = (e) => onPointerUp(e.clientX, e.clientY, e);
      el.addEventListener('pointerup', peEnd, { passive: true });
      el.addEventListener('pointercancel', peEnd, { passive: true });
      el.addEventListener('pointerleave', peEnd, { passive: true });
    } else {
      // Fallback: Touch Events
      el.addEventListener('touchstart', (e) => {
        const t = e.changedTouches[0];
        onPointerDown(t.clientX, t.clientY);
      }, { passive: true });

      el.addEventListener('touchmove', (e) => {
        const t = e.changedTouches[0];
        onPointerMove(t.clientX, t.clientY, e);
      }, { passive: false });

      el.addEventListener('touchend', (e) => {
        const t = e.changedTouches[0];
        onPointerUp(t.clientX, t.clientY, e);
      }, { passive: true });

      el.addEventListener('touchcancel', (e) => {
        const t = e.changedTouches[0];
        onPointerUp(t?.clientX || 0, t?.clientY || 0, e);
      }, { passive: true });
    }
  }
  qa('.product-gallery').forEach(bindGallery);

  // ---------- Auto-open ONCE (no repeated enforcement) ----------
  function fallbackIdsForPreset(p) {
    switch (p) {
      case 'generic':  return ['sort', 'price'];   // Sort + Price only
      case 'all':      return ['taxonomy'];        // Product Type
      case 'expander': return ['expander_size'];   // Expander Size
      case 'pods':     return ['pod_size'];        // Pod Size
      case 'cabins':   return ['cabin_size'];      // Cabin Size
      case 'domes':    return ['dome_width'];      // Dome Width
      default:         return [];
    }
  }

  function setOpen(id, open) {
    const btn   = q(`.filter-toggle[data-filter="${id}"]`);
    const panel = q(`.filter-content[data-filter-content="${id}"]`);
    if (!btn || !panel) return;
    btn.classList.toggle('active', !!open);
    panel.classList.toggle('active', !!open);
  }

  // Respect server state first. If nothing is open, fall back to preset.
  (function applyInitialAutoOpen() {
    if (!sidebar || sidebar.dataset.autoInit === '1') return;

    // Run on next frame to avoid clobbering server-rendered state during hydration
    requestAnimationFrame(() => {
      if (sidebar.dataset.autoInit === '1') return;

      const initiallyOpen = Array.from(qa('.filter-content.active'))
        .map(p => p.dataset.filterContent)
        .filter(Boolean);

      if (!initiallyOpen.length) {
        // Close all then open the relevant ones
        qa('.filter-content').forEach(c => c.classList.remove('active'));
        qa('.filter-toggle').forEach(b => b.classList.remove('active'));
        fallbackIdsForPreset(preset).forEach(id => setOpen(id, true));
      }

      // Never auto-open again
      sidebar.dataset.autoInit = '1';
    });
  })();

  // initial run
  scheduleFilter();
});
